import { api } from '../utils/axios';

export const getServers = () => async (dispatch) => {
  
  let data = {};

  dispatch({
    type: "GET_SERVERS_REQUESTED"
  });
  try {
    const response = await api.post('admin/get_servers', data);
    dispatch({
      type: "GET_SERVERS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "GET_SERVERS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const deleteServer = (server_id) => async (dispatch) => {
  
  let data = {};
  data.focus = true;
  data.target_server = { "server_id": server_id };

  dispatch({
    type: "DELETE_SERVERS_REQUESTED"
  });
  try {
    const response = await api.post('admin/delete_server', data);
    dispatch({
      type: "DELETE_SERVERS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DELETE_SERVERS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const updateServer = (userData) => async (dispatch) => {
  
  let data = {};
  data.target_server = userData;

  dispatch({
    type: "UPDATE_SERVER_REQUESTED"
  });
  try {
    const response = await api.post('admin/update_server', data);
    dispatch({
      type: "UPDATE_SERVER_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "UPDATE_SERVER_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

export const createServer = (userData) => async (dispatch) => {
    let data = {target_server: userData};
    dispatch({
      type: "CREATE_SERVER_REQUESTED"
    });

    try {
    const response = await api.post('admin/create_server', data);
    dispatch({
        type: "CREATE_SERVER_SUCCESS",
        response: response
      });
      return { response }
    } catch (e) {
      dispatch({
        type: "CREATE_SERVER_FAILED",
        error: e.error
      });
    }
}

export function setAgentPageInfo({ pageSize, pageNo }) {
  return {
    type: 'SET_AGENT_PAGEINFO',
    payload: { pageSize, pageNo }
  }
}

export const destroyAgentKasms = (server_id) => async (dispatch) => {
  
  let data = {};
  data.focus = true;
  data.target_server = { "server_id": server_id };

  dispatch({
    type: "DESTROY_AGENT_KASMS_REQUESTED"
  });
  try {
    const response = await api.post('admin/destroy_agent_kasms', data);
    dispatch({
      type: "DESTROY_AGENT_KASMS_SUCCESS",
      response: response
    });
    return { response }
  } catch (e) {
    dispatch({
      type: "DESTROY_AGENT_KASMS_FAILED",
      error: e.error
    });
    throw new Error(e.error);
  }
}

